module.exports = __webpack_public_path__ + "static/media/pagamento-pix.97b8c201.svg";